const es = {
    translation: {
        button: {
            backToAccountServices: 'REGRESAR A SERVICIOS DE CUENTA',
            changeDueDate: 'Cambiar Fecha de Vencimiento',
            close: 'CERRAR'
        },
        changePaymentDueDate: 'Cambiar fecha de vencimiento de pago',
        currentPaymentDueDate: 'Fecha de Vencimiento del Pago Actual',
        disclaimer: {
            disclaimer: 'Al hacer clic en "Solicitar Cambio", procesaremos su solicitud de Cambio de Fecha de Vencimiento. Por favor, tenga en cuenta: su Pago Mínimo Adeudado puede aumentar en su próximo estado de cuenta como resultado de esta solicitud.',
            note: '<strong>Nota:</strong> Se le permite 1 cambio de fecha de vencimiento en un período de 12 meses.'
        },
        errorMessages: {
            dueDateChangePeriodRestriction: {
                subTitle: 'Puede cambiar su fecha de vencimiento una vez cada 12 meses.',
                title: 'Usted no puede cambiar su fecha de vencimiento ahora mismo'
            },
            notEligible: {
                title: 'Su cuenta no es elegible',
                body: 'En este momento no podemos procesar su solicitud de Cambiar la Fecha de Vencimiento.'
            },
            troubleRetrievingInformation: 'Tenemos problemas para recuperar su información',
            tryAgainLater: 'Por favor, vuelva a intentarlo más tarde.'
        },
        header: {
            currentDueDate: {
                date: '{{date}} de todos los meses',
                title: 'FECHA DE VENCIMIENTO DEL PAGO ACTUAL'
            },
            selectDateError: 'Por favor, seleccione una nueva fecha de vencimiento del pago.',
            selectTheDate: 'Seleccione a continuación la fecha que usted desea establecer como su nueva fecha de vencimiento de pago',
            title: 'Cambiar su Fecha de Vencimiento'
        },
        modalHeader: 'Cambiar Fecha de Vencimiento',
        selectedDueDate: 'Fecha de Vencimiento Seleccionada',
        successfulScreen: {
            currentDate: '{{date}} del mes',
            currentPaymentDueDate: 'Fecha de Vencimiento del Pago del Estado de Cuenta Actual',
            details: 'Detalles',
            newDate: '{{date}} del mes',
            newPaymentDueDate: 'Nueva Fecha de Vencimiento del Pago',
            note: '<strong>Nota:</strong> Si está inscrito en Autopay, este cambio también se aplicará a sus pagos de Autopay.',
            subTitleOne: 'El cambio en su fecha de vencimiento aparecerá primero en su próximo estado de cuenta.',
            subTitleTwo: 'Hasta entonces, su fecha de vencimiento actual no cambiará.',
            title: 'Ha cambiado exitosamente su fecha de vencimiento'
        },
        promosExtendedMessageBox: {
            body: 'Por favor, consulte su próximo estado de cuenta para ver la fecha de vencimiento de su promoción ajustada.',
            title: 'La fecha de vencimiento de su promoción existente ha cambiado'
        },
        unableToProcessRequest: 'Lamentablemente no podemos procesar su solicitud en este momento.'
    }
};
export default es;
